var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapspecialtymarker = function SvgMapspecialtymarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mapspecialtymarker_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mapspecialtymarker_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.13 2C7.993 2 3 7.19 3 13.573c0 7.998 9.807 16.915 10.225 17.29.261.236.583.354.905.354.323 0 .645-.118.906-.353.418-.376 10.225-9.293 10.225-17.291C25.26 7.19 20.267 2 14.13 2Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.13 2C7.993 2 3 7.19 3 13.573c0 7.998 9.807 16.915 10.225 17.29.261.236.583.354.905.354.323 0 .645-.118.906-.353.418-.376 10.225-9.293 10.225-17.291C25.26 7.19 20.267 2 14.13 2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.225 30.864-1.338 1.487 1.338-1.487Zm1.811 0 1.337 1.487-1.337-1.487ZM14.13 0C6.816 0 1 6.16 1 13.573h4C5 8.221 9.17 4 14.13 4V0ZM1 13.573c0 4.704 2.823 9.39 5.367 12.718 2.61 3.416 5.269 5.833 5.52 6.06l2.675-2.974c-.166-.15-2.62-2.378-5.017-5.515C7.08 20.64 5 16.867 5 13.573H1Zm10.887 18.778a3.35 3.35 0 0 0 2.243.866v-4c.174 0 .328.067.432.16l-2.675 2.974Zm2.243.866a3.35 3.35 0 0 0 2.243-.866L13.7 29.377a.65.65 0 0 1 .431-.16v4Zm2.244-.866c.251-.227 2.91-2.644 5.52-6.06 2.544-3.328 5.367-8.014 5.367-12.718h-4c0 3.294-2.08 7.066-4.545 10.29-2.397 3.136-4.852 5.365-5.017 5.514l2.675 2.974ZM27.26 13.573C27.26 6.16 21.445 0 14.13 0v4c4.96 0 9.13 4.221 9.13 9.573h4Z",
    fill: "#D9B302",
    mask: "url(#mapspecialtymarker_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.131,
    cy: 13.13,
    r: 4.174,
    fill: "#D9B302"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mapspecialtymarker_svg__a",
    x: 0,
    y: 0,
    width: 28.262,
    height: 35.217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1702_39879"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1702_39879",
    result: "effect2_dropShadow_1702_39879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1702_39879",
    result: "shape"
  })))));
};
export default SvgMapspecialtymarker;